// src/assets/components/images.js
const importAll = (r) => {
  const images = {};
  r.keys().forEach((key) => {
    const fileName = key.replace("./", "");
    images[fileName] = r(key);
  });
  return images;
};

// Passe den Pfad zu deinem Bilder-Ordner an
const images = importAll(
  require.context("../assets/img", false, /\.(png|jpe?g|webp|svg)$/)
);

export default images;
